import React from 'react';
import './App.css';
import StartupHomepage from './components/StartupHomepage';
import ColorDemo from './components/ColorDemo';

function App() {
  const isColorDemo = window.location.pathname === '/color-demo' || window.location.search.includes('demo=colors');

  return (
    <div className="App">
      {isColorDemo ? <ColorDemo /> : <StartupHomepage />}
    </div>
  );
}

export default App;
